import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomSearchBox from "../../Components/CustomSearch";
import TableContainer from "../../Components/TableContainer";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { toast } from "react-toastify";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import DummyUser from "../../Assets/User.webp";
import { Navigate, useNavigate } from "react-router-dom";
const UserManagement = () => {
  const pageSize = 15;
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  // Comp dialog — the influencer-gift path. Grants a REAL RevenueCat
  // promotional entitlement + the backend premium row for N days: no
  // payment method, no auto-renew, expires silently. (Apple killed in-app
  // promo entry under 3.1.1, so the grant lives here instead.)
  const [comp, setComp] = useState(null); // { user, days, busy }
  const getUserList = async (params) => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post(ApiList.USER_GET, params);
      if (response?.data?.s === 1) {
        const formattedUsers = response?.data?.r?.map((user, index) => ({
          rowid: index + 1 + page * pageSize,
          ...user,
        }));
        setUserData(formattedUsers);
        if (params.skip === 0) {
          const totalCount = response?.data?.total || 0;
          localStorage.setItem("totalCount", totalCount);
          setTotalData(totalCount);
        } else {
          const totalCountFromStorage = localStorage.getItem("totalCount");
          setTotalData(
            totalCountFromStorage ? Number(totalCountFromStorage) : 0
          );
        }
        setLoading(false);
      } else {
        setUserData([]);
        setTotalData(0);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setLoading(false);
    }
  };
  const fetchUserList = () => {
    const skip = page * pageSize;
    const total = `1`;
    const computedSearchArg = searchTerm
      ? `u.status = 1 AND u.fname LIKE "%${searchTerm}%" AND u.role != 2`
      : "u.status = 1 AND u.role != 2";
    const params = {
      select:
        "u.*,(SELECT COUNT(ud.id) FROM user_dogs AS ud WHERE ud.user_id = u.id AND ud.status = 1) AS total_dog",
      from: "users AS u",
      arg: computedSearchArg,
      order: "u.id DESC",
      skip,
      limit: pageSize,
      total: total,
    };
    getUserList(params);
  };
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };
  useEffect(() => {
    fetchUserList();
  }, [searchTerm, page]);
  const columns = [
    {
      field: "rowid",
      headerName: "Sr.No",
      width: 80,
      align: "center",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "image",
      headerName: "Profile",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Avatar
          sx={{
            width: "40px",
            height: "40px",
            objectFit: "contain",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              params?.row?.image
                ? `${ApiList.IMG_URL}${params?.row?.image}`
                : DummyUser
            }
            style={{ width: "100%", height: "100%" }}
          ></img>
        </Avatar>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const name = `${params?.row?.fname || ""} ${params?.row?.lname || ""}`;
        const truncatedCaption =
          name?.length > 20 ? `${name.substring(0, 20)}...` : name;
        return (
          <Tooltip title={`${params?.row?.fname} ${params?.row?.lname}`}>
            {truncatedCaption}
          </Tooltip>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const email = params.row.email;
        const truncatedCaption =
          email?.length > 20 ? `${email.substring(0, 20)}...` : email;
        return <Tooltip title={params?.row?.email}>{truncatedCaption}</Tooltip>;
      },
    },
    {
      field: "username",
      headerName: "User Name",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const userName = params?.row?.username;
        const truncatedCaption =
          userName?.length > 20 ? `${userName.substring(0, 20)}...` : userName;
        return (
          <Tooltip title={params?.row?.username}>{truncatedCaption}</Tooltip>
        );
      },
    },
    {
      field: "total_dog",
      headerName: "No. of Dogs",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "Action",
      headerName: "Action",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <IconButton
              onClick={() =>
                navigate("/user/user-profile", {
                  state: {
                    id: params?.row?.id,
                  },
                })
              }
            >
              <RemoveRedEyeIcon sx={{ color: "#b9cc03" }} />
            </IconButton>
            <Tooltip title="Gift Premium (influencer comp)">
              <IconButton
                onClick={() => setComp({ user: params?.row, days: 90 })}
              >
                <WorkspacePremiumIcon sx={{ color: "#e0a900" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  const grantComp = async () => {
    if (!comp?.user?.id) return;
    setComp((c) => ({ ...c, busy: true }));
    try {
      const res = await AxiosInstance.post(ApiList.ADMIN_PREMIUM_GRANT, {
        user_id: comp.user.id,
        days: comp.days,
      });
      if (res?.data?.s === 1) {
        // The message carries the expiry — and calls out an RC half-grant
        // loudly, because that means the app side did not get premium.
        if (res?.data?.r?.rc_granted === false) {
          toast.error(res?.data?.m, { autoClose: 12000 });
        } else {
          toast.success(res?.data?.m, { autoClose: 8000 });
        }
        setComp(null);
      } else {
        toast.error(res?.data?.m || "Grant failed");
        setComp((c) => ({ ...c, busy: false }));
      }
    } catch (e) {
      toast.error(e?.message || "Grant failed");
      setComp((c) => ({ ...c, busy: false }));
    }
  };

  const revokeComp = async () => {
    if (!comp?.user?.id) return;
    setComp((c) => ({ ...c, busy: true }));
    try {
      const res = await AxiosInstance.post(ApiList.ADMIN_PREMIUM_REVOKE, {
        user_id: comp.user.id,
      });
      if (res?.data?.s === 1) {
        toast.success(res?.data?.m, { autoClose: 8000 });
        setComp(null);
      } else {
        toast.error(res?.data?.m || "Revoke failed");
        setComp((c) => ({ ...c, busy: false }));
      }
    } catch (e) {
      toast.error(e?.message || "Revoke failed");
      setComp((c) => ({ ...c, busy: false }));
    }
  };

  return (
    <>
      <Dialog open={!!comp} onClose={() => !comp?.busy && setComp(null)} maxWidth="xs" fullWidth>
        <DialogTitle>
          Gift Premium — {comp?.user?.username || comp?.user?.email || `user ${comp?.user?.id}`}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Grants real Premium (app + backend) with no payment method and no
            auto-renew — it simply expires. Granting again while active
            EXTENDS from the current expiry.
          </Typography>
          <TextField
            select
            fullWidth
            size="small"
            label="Duration"
            value={comp?.days ?? 90}
            onChange={(e) => setComp((c) => ({ ...c, days: e.target.value }))}
          >
            <MenuItem value={7}>1 week</MenuItem>
            <MenuItem value={30}>1 month</MenuItem>
            <MenuItem value={90}>3 months (influencer standard)</MenuItem>
            <MenuItem value={180}>6 months</MenuItem>
            <MenuItem value={365}>1 year</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, justifyContent: "space-between" }}>
          <Button color="error" size="small" disabled={comp?.busy} onClick={revokeComp}>
            Revoke comp
          </Button>
          <Box>
            <Button disabled={comp?.busy} onClick={() => setComp(null)}>
              Cancel
            </Button>
            <Button variant="contained" disabled={comp?.busy} onClick={grantComp}>
              Grant
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#B9CC0310",
          overflow: "hidden",
        }}
      >
        <Box sx={{ width: "100%", p: 2, background: "#B9CC0310" }}>
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "28px" },
              fontWeight: "300",
              color: "#000",
            }}
          >
            User Management
          </Typography>
        </Box>
        <Box sx={{ width: "100%", height: "calc(100vh - 74px)" }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 1,
            }}
          >
            <Box sx={{ width: "400px" }}>
              <CustomSearchBox placeholder={"Search"} onChange={handleSearch} />
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "calc(100vh - 142.67px)",
              p: 1,
              overflow: "scroll",
            }}
          >
            <TableContainer
              columns={columns}
              rows={userData}
              handlePageChange={handlePageChange}
              page={page}
              loading={loading}
              totalData={totalData}
              pageSize={pageSize}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default UserManagement;
